import moment from 'moment';
import { useForm } from 'react-final-form';
import { useCallback } from 'react';
import QCXDateTimePicker from '../date-time-picker/QCXDateTimePicker';
import QCXFinalField from '../final-field/QCXFinalField';

export default function QCXFinalDateTimePickerField({
  name,
  label,
  format = 'DD/MM/YYYY HH:mm',
  placeholder = 'DD/MM/YYYY hh:mm',
  disablePast = false,
  disableFuture = false,
  defaultToStartOfDay = false,
  minDate = moment('1900-01-01').toDate(),
  ...restProps
}) {
  const form = useForm();

  const handleDoubleClick = useCallback(() => {
    form.change(name, moment());
  }, []);

  const parseDataSemHora = useCallback(
    (inputValue) => {
      if (!defaultToStartOfDay || typeof inputValue !== 'string') {
        return undefined;
      }

      const [dateFormat] = format.split(' ');
      const [dateInput] = inputValue.split(' ');
      const data = moment(dateInput, dateFormat, true);

      return data.isValid() ? data.startOf('day') : undefined;
    },
    [defaultToStartOfDay, format]
  );

  return (
    <QCXFinalField
      fullWidth
      name={name}
      render={({ input: { name: inputName, value, onChange, ...restInput }, meta, ...restComponentProps }) => {
        const showError = ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched;

        const handleBlur = (event) => {
          if (!moment(value || null).isValid()) {
            const dataSemHora = parseDataSemHora(event?.target?.value);

            if (dataSemHora) {
              onChange(dataSemHora);
            }
          }

          restInput.onBlur?.(event);
        };

        return (
          <QCXDateTimePicker
            onDoubleClick={handleDoubleClick}
            name={inputName}
            label={label}
            value={value === '' ? null : value}
            onChange={onChange}
            format={format}
            placeholder={placeholder}
            error={showError}
            inputProps={{ ...restInput, onBlur: handleBlur }}
            helperText={showError ? meta.error || meta.submitError : undefined}
            disablePast={disablePast}
            disableFuture={disableFuture}
            minDate={minDate}
            initialFocusedDate={defaultToStartOfDay ? moment().startOf('day') : undefined}
            {...restComponentProps}
          />
        );
      }}
      {...restProps}
    />
  );
}
